import { Pipe, PipeTransform } from '@angular/core';
import { join, remove } from 'lodash-es';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateScheduleTab',
})
export class TranslateScheduleTabPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    const scheduleType = this.removeNumbers(value);
    if (scheduleType && this.customTranslationsService.SCHEDULES[scheduleType]) {
      return this.translateService.instant(this.customTranslationsService.SCHEDULES[scheduleType]);
    }

    return value;
  }

  private removeNumbers(featureName: string): string {
    // e.g. 'heating.circuits.2.dhw.schedule' -> 'heating.circuits.dhw.schedule'
    return join(
      remove(featureName.split('.'), (chunk) => isNaN(+chunk)),
      '.'
    ) as string;
  }
}
